export default function ($scope, $uibModalInstance, c, all) {

    $scope.class = c.class;
    $scope.course = c;
    $scope.all = all;

    $scope.courseDetailHref = '/learn/courses-and-programs/courses/' +
        $scope.course.courseCode.toLowerCase();

    $scope.close = function() {
        $uibModalInstance.dismiss();
    };

};